import { render, staticRenderFns } from "./NewsAdminCreate.vue?vue&type=template&id=19252204"
import script from "./NewsAdminCreate.vue?vue&type=script&lang=js"
export * from "./NewsAdminCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports